import { render, staticRenderFns } from "./product_galaries.vue?vue&type=template&id=6360e306"
import script from "./product_galaries.vue?vue&type=script&lang=js"
export * from "./product_galaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports